$(document).ready(function () {
	// Full Width Slide Show
	$(".wp-block-gallery.is-style-slide-show").wrap('<div class="slider"/>').wrap('<div class="slider-container"/>').contents().unwrap();
	// $('.slider-container ul').wrap('<div class="slider"/>').contents().unwrap();
	// $('.slider-container li').wrap('<div class="slide-item"/>').contents().unwrap();

	$(".slider-container .slider").slick({
		autoplay: true,
		autoplaySpeed: 3500,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
		mobileFirst: true,
		adaptiveHeight: true,
	});

	// Favorites Slide Show
	// $('.wp-block-gallery.is-style-favorites-slide-show').wrap('<div class="slider"/>').wrap('<div class="favorites-slider-container"/>').contents().unwrap();
	// $('.favorites-slider-container ul').wrap('<div class="slider"/>').contents().unwrap();
	// $('.favorites-slider-container li').wrap('<div class="slider-item"/>').contents().unwrap();

	$(".is-style-favorites-slide-show").slick({
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: false,
		// prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
		// nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: false,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					dots: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
				},
			},
		],
	});

	$("body").on("click", ".favorites-slider-container .slider-item", function () {
		window.location.href = "/menu/";
	});

	// Ticker Slide Show
	$(".wp-block-gallery.is-style-ticker-slide-show ul li:gt(20)").remove();
	$(".wp-block-gallery.is-style-ticker-slide-show").wrap('<div class="slider"/>').wrap('<div class="ticker-slide-show-container"/>').contents().unwrap();
	// $('.ticker-slide-show-container ul').wrap('<div class="slider"/>').contents().unwrap();
	// $('.ticker-slide-show-container li').wrap('<div class="slide-item"/>').contents().unwrap();
	// $('.ticker-slide-show-container .slider').randomize('.slide-item');

	$(".ticker-slide-show-container .slider").slick({
		accessibility: false,
		draggable: false,
		arrows: false,
		fade: false,
		mobileFirst: false,
		autoplay: true,
		arrows: false,
		speed: 0,
		autoplaySpeed: 4000,
		dots: false,
		infinite: true,
		slidesToShow: 7,
		slidesToScroll: 7,
		infinite: true,
		cssEase: "linear",
		pauseOnFocus: false,
		pauseOnHover: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 7,
					slidesToScroll: 7,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 5,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
		],
	});

	$(".column-slider-container").slick({
		autoplay: true,
		autoplaySpeed: 2000,
		prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
		nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
		centerPadding: 0,
		mobileFirst: true,
		variableWidth: true,
		centerMode: true,
		swipeToSlide: true,
	});
});

(function ($) {
	$.fn.randomize = function (tree, childElem) {
		return this.each(function () {
			var $this = $(this);
			if (tree) $this = $(this).find(tree);
			var unsortedElems = $this.children(childElem);
			var elems = unsortedElems.clone();

			elems.sort(function () {
				return Math.round(Math.random()) - 0.5;
			});

			for (var i = 0; i < elems.length; i++) unsortedElems.eq(i).replaceWith(elems[i]);
		});
	};
})(jQuery);
